import { ArrowRight, ChevronDown } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/5d609f59-ef3b-4635-81e0-3a6a2e70cc39/images/e05c2029bb9d10fbf6d46ad174be7dd230923e37d98921e5ec89342235a8703d.png";

const Hero = ({ t, onOpenConsult }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-end overflow-hidden"
    >
      {/* BG Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Engenharia industrial e segurança do trabalho"
          className="w-full h-full object-cover"
        />
        {/* Dark gradient overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a192f]/95 via-[#0a192f]/75 to-[#0a192f]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f] via-transparent to-transparent" />
      </div>

      {/* Decorative grid lines */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      {/* Content */}
      <div className="relative bid-container pt-32 pb-20 sm:pb-32">
        <div className="max-w-3xl">
          <p className="bid-overline text-[#d4af37] mb-6 fade-up" data-testid="hero-overline">
            {t.hero.overline}
          </p>
          <h1
            className="text-4xl sm:text-5xl lg:text-7xl font-display font-black text-white leading-[1.05] tracking-tight fade-up delay-1"
            data-testid="hero-title"
          >
            {t.hero.title}
          </h1>
          <p
            className="mt-6 text-base sm:text-lg lg:text-xl text-white/80 max-w-2xl leading-relaxed fade-up delay-2"
            data-testid="hero-subtitle"
          >
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 fade-up delay-3">
            <button
              onClick={onOpenConsult}
              data-testid="hero-cta-primary"
              className="btn-primary group"
            >
              {t.hero.cta}
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="btn-secondary"
            >
              {t.hero.ctaSecondary}
            </a>
          </div>

          <div className="mt-10 flex items-center gap-3 fade-up delay-4">
            <div className="w-10 h-px bg-[#d4af37]" />
            <p className="font-display italic text-white/90 text-sm sm:text-base">
              "{t.hero.slogan}"
            </p>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-16 sm:mt-24 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 fade-up delay-5">
          {t.hero.stats.map((s, i) => (
            <div
              key={i}
              className="bg-[#0a192f]/70 backdrop-blur-sm p-6 sm:p-8"
              data-testid={`hero-stat-${i}`}
            >
              <div className="font-display text-3xl sm:text-4xl font-black text-[#d4af37]">
                {s.value}
              </div>
              <div className="bid-overline text-white/70 text-[10px] mt-2 leading-tight">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll cue */}
      <a
        href="#about"
        className="hidden sm:flex absolute bottom-6 left-1/2 -translate-x-1/2 flex-col items-center gap-1 text-white/60 hover:text-[#d4af37] transition-colors"
        aria-label="scroll"
      >
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <ChevronDown className="w-4 h-4 animate-bounce" />
      </a>
    </section>
  );
};

export default Hero;
